import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';

export const getSiteContextBaseSiteState = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state?.baseSite,
);

export const getActiveBaseSiteEntity = createSelector(
  getSiteContextBaseSiteState,
  (state) => state?.entities?.[state.activeSite],
);

export const getActiveBaseSite = createSelector(
  getSiteContextBaseSiteState,
  (state) => state?.activeSite,
);

export const getBaseSitesEntities = createSelector(
  getSiteContextBaseSiteState,
  (state) => state?.entities,
);

export const getAllBaseSites = createSelector(
  getBaseSitesEntities,
  (entities) => {
    return entities ? Object.keys(entities).map((uid) => entities[uid]) : null;
  },
);

export const getCultureEntities = createSelector(
  getSiteContextBaseSiteState,
  (state) => state?.isocodes,
);

export const getOnlineCultureEntities = createSelector(
  getSiteContextBaseSiteState,
  (state) => state?.onlineIsocodes,
);
